import { IMapMarkerIcon, ITileLayerInfo } from "../Features/MapComponents/layers";
import { IIndexedDbTileCacheOptions } from "../Features/MapComponents/TileCache/indexedDB/types";
import { ILeafletTileLayerSnapshotGeneratorOptions } from "../Features/MapComponents/Leaflet/SnapshotGenerator/leafletSnapshotGenerator";
import { DistanceUnits, HeadingUnit } from "../Features/Common/Units/types";


export interface ISettingOption<IdType> {
    id: IdType;
    name: string;
};

export interface IConfig {
    defaultCentre: L.LatLng;
    locale: Intl.Locale;
    ui: IUIConfig;
    tileCacheSeeder: IIndexedDbTileCacheOptions;
    mapSnapshotGenerator: ILeafletTileLayerSnapshotGeneratorOptions;
    maxBounds: L.LatLngBounds;
    tileLayers: ITileLayerInfo[];
    icons: IIconConfig;
};

export interface IUIConfig {
    placeSearchOSApiUrl: string;
    placeSearchMaxResults: number;
    placeHistoryMaxItems: number;
    notifierAutoHideDurationMs: number;
    notifierMaxItems: number;
};

export interface IIconConfig {
    currentLocationWithHeading: IMapMarkerIcon;
    currentLocationNoHeading: IMapMarkerIcon;
};

export interface ISettings {
    map: IMapSettings;
    tileCache: ITileCacheSettings;
    ui: IUISettings;
};


export enum MapLocationTrackingBehaviour {
    Always = 0,
    TurnOffOnPan = 1
};

export interface IMapSettings {
    defaultLayerId?: string;
    locationTrackingBehaviour: MapLocationTrackingBehaviour;
};

export interface ITileCacheSettings {
    activeCacheSeederId?: string | null;
};

export enum ToolbarFlowOrientation {
    RightHanded = 0,
    LeftHanded = 1
};

export interface IUISettings {
    headingUnit: HeadingUnit;
    distanceUnits: DistanceUnits;
    toolbarFlowOrientation: ToolbarFlowOrientation;
};

export interface IMapSnapshotState {
    centre: L.LatLng | null;
    zoom: number | null;
    layerId: string | null;
};